import { render, staticRenderFns } from "./register-info.vue?vue&type=template&id=6403abe8&scoped=true"
import script from "./register-info.vue?vue&type=script&lang=js"
export * from "./register-info.vue?vue&type=script&lang=js"
import style0 from "./register-info.vue?vue&type=style&index=0&id=6403abe8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6403abe8",
  null
  
)

export default component.exports